module.exports = __webpack_public_path__ + "images/large_panda.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/large_panda.jpg
// module id = 1118
// module chunks = 1